export var platformTypes = /*#__PURE__*/function (platformTypes) {
  platformTypes["appStore"] = "Appstore";
  platformTypes["playMarket"] = "Playmarket";
  platformTypes["huaweiStore"] = "Huaweistore";
  platformTypes["ruStore"] = "Rustore";
  return platformTypes;
}({});